/*
 * Flayvr Ami v27
 * Logic-only replacement for sections/flayvr-ami-home-v27.liquid.
 * Uses the existing flayvr-ami-final-v25.css without modifying design styles.
 */
(function () {
  'use strict';

  var VERSION = '2.15.5';
  var STORAGE_KEY = 'flayvr_ami_final_v27';
  var LEGACY_KEYS = [
    'flayvr_ami_final_v26',
    'flayvr_ami_final_v2114',
    'flayvr:ami-ai-chatbot:v8',
    'flayvr:ami-ai-chatbot:v7',
    'flayvr:ami-ai-chatbot:v6',
    'flayvr:ami-ai-chatbot:v5',
    'flayvr:ami-ai-chatbot:v4',
    'flayvr:ami-ai-chatbot:v3'
  ];
  var MEMORY_MS = 30 * 24 * 60 * 60 * 1000;

  var COVERAGE = {
    '40': {
      label: 'Weekday dinners',
      detail: 'Five dinners, Monday to Friday',
      price: 40,
      slots: { Dinner: 5 }
    },
    '80': {
      label: 'Weekday lunch + dinner',
      detail: 'Lunch and dinner, Monday to Friday',
      price: 80,
      slots: { Lunch: 5, Dinner: 5 }
    },
    '120': {
      label: 'Full seven-day plan',
      detail: 'Breakfast, lunch, dinner and snacks for all seven days',
      price: 120,
      slots: { Breakfast: 7, Lunch: 7, Dinner: 7, Snack: 7 }
    }
  };

  var STEPS = [
    {
      id: 'name',
      question: 'Who are the meals for?',
      type: 'text',
      skippable: true,
      placeholder: 'Name, or tap Skip'
    },
    {
      id: 'coverage',
      question: 'What would you like me to cover?',
      type: 'coverage'
    },
    {
      id: 'diet',
      question: 'Anything our chefs need to work around?',
      type: 'multi',
      choices: [
        'No restrictions',
        'Vegetarian',
        'Vegan',
        'Pescatarian',
        'Gluten-free',
        'Dairy-free'
      ]
    },
    {
      id: 'avoids',
      question: 'Anything you dislike or need us to avoid?',
      type: 'text',
      skippable: true,
      placeholder: 'Type an ingredient, or tap Skip'
    },
    {
      id: 'spice',
      question: 'How do you like your spice?',
      type: 'single',
      choices: ['Mild', 'Medium', 'Hot', 'Depends on the dish']
    },
    {
      id: 'goal',
      question: 'What would make this week feel better?',
      type: 'multi',
      skippable: true,
      choices: [
        'Steady energy',
        'Higher protein',
        'Gut-friendly meals',
        'Lighter eating',
        'Comfort food',
        'Less decision-making'
      ]
    }
  ];

  function blankState() {
    return {
      name: '',
      diet: [],
      avoids: '',
      spice: 'Medium',
      coverage: '80',
      goal: [],
      menu: [],
      completed: [],
      currentStepId: '',
      editingCoverage: false
    };
  }

  function esc(value) {
    return String(value == null ? '' : value).replace(/[&<>"']/g, function (character) {
      return {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#039;'
      }[character];
    });
  }

  function clone(value) {
    return JSON.parse(JSON.stringify(value));
  }

  function list(value) {
    if (Array.isArray(value)) {
      return value.map(function (item) {
        return String(item == null ? '' : item).trim();
      }).filter(Boolean);
    }

    if (value && typeof value === 'object') {
      if (Array.isArray(value.value)) {
        return list(value.value);
      }
      if (value.value != null && typeof value.value !== 'object') {
        return list(value.value);
      }
    }

    return String(value == null ? '' : value)
      .split(/[,;|]+/)
      .map(function (item) { return item.trim(); })
      .filter(Boolean);
  }

  function lower(value) {
    return list(value).map(function (item) { return item.toLowerCase(); });
  }

  function firstName(value) {
    return String(value || '').trim().split(/\s+/)[0].slice(0, 50);
  }

  function cleanText(value) {
    return String(value || '')
      .toLowerCase()
      .replace(/[_-]+/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function booleanValue(value, fallback) {
    if (value === true || value === false) return value;
    if (value === 1 || value === 0) return Boolean(value);

    var text = String(value == null ? '' : value).trim().toLowerCase();
    if (!text) return fallback;
    if (['false', '0', 'no', 'off', 'inactive', 'unavailable'].indexOf(text) >= 0) return false;
    if (['true', '1', 'yes', 'on', 'active', 'available'].indexOf(text) >= 0) return true;
    return fallback;
  }

  function bootAll(scope) {
    var context = scope && scope.querySelectorAll ? scope : document;
    var roots = context.querySelectorAll('[data-flayvr-ami-v27]');
    Array.prototype.forEach.call(roots, initRoot);
  }


  function initMotionRows(root) {
    var canvas = root.querySelector('.flami-visual');
    var rows = Array.prototype.map.call(
      root.querySelectorAll('[data-ami-motion-row]'),
      function (track) {
        var group = track.querySelector('[data-ami-motion-group]');
        return {
          track: track,
          group: group,
          row: track.getAttribute('data-ami-motion-row'),
          baseCards: group
            ? Array.prototype.map.call(group.children, function (card) { return card.cloneNode(true); })
            : []
        };
      }
    );

    if (!rows.length) return function () {};

    var resizeTimer = 0;

    function cardWidth() {
      var styles = window.getComputedStyle(root);
      var variable = window.matchMedia('(max-width:820px)').matches
        ? '--ami-motion-card-width-mobile'
        : '--ami-motion-card-width';
      return parseFloat(styles.getPropertyValue(variable)) || 246;
    }

    function prepare(entry) {
      if (!entry.group || !entry.baseCards.length) return;

      entry.track.classList.remove('is-ready');
      Array.prototype.forEach.call(
        entry.track.querySelectorAll('[data-ami-motion-clone]'),
        function (clone) { clone.remove(); }
      );

      entry.group.replaceChildren();
      entry.baseCards.forEach(function (card) {
        entry.group.appendChild(card.cloneNode(true));
      });

      var minimum = (canvas ? canvas.clientWidth : root.clientWidth) + (cardWidth() * 2);
      var guard = 0;

      while (entry.group.getBoundingClientRect().width < minimum && guard < 80) {
        entry.group.appendChild(entry.baseCards[guard % entry.baseCards.length].cloneNode(true));
        guard += 1;
      }

      var clone = entry.group.cloneNode(true);
      clone.removeAttribute('data-ami-motion-group');
      clone.setAttribute('data-ami-motion-clone', '');
      clone.setAttribute('aria-hidden', 'true');
      entry.track.appendChild(clone);

      var distance = Math.ceil(entry.group.getBoundingClientRect().width);
      root.style.setProperty(
        entry.row === 'top' ? '--ami-row-top-distance' : '--ami-row-bottom-distance',
        distance + 'px'
      );

      void entry.track.offsetWidth;
      entry.track.classList.add('is-ready');
    }

    function prepareAll() {
      rows.forEach(prepare);
    }

    function schedule() {
      window.clearTimeout(resizeTimer);
      resizeTimer = window.setTimeout(prepareAll, 120);
    }

    prepareAll();
    window.addEventListener('load', prepareAll, { once: true });
    window.addEventListener('resize', schedule, { passive: true });

    return function () {
      window.clearTimeout(resizeTimer);
      window.removeEventListener('resize', schedule);
    };
  }

  function initRoot(root) {
    if (!root || root.dataset.amiInitialised === VERSION) return;
    root.dataset.amiInitialised = VERSION;

    initMotionRows(root);

    var chat = root.querySelector('[data-ami-chat]');
    var input = root.querySelector('[data-ami-input]');
    var send = root.querySelector('[data-ami-send]');
    var review = root.querySelector('[data-ami-review]');
    var memory = root.querySelector('[data-ami-memory]');
    var memoryToggle = root.querySelector('[data-ami-memory-toggle]');
    var memoryList = root.querySelector('[data-ami-memory-list]');
    var menuGroups = root.querySelector('[data-ami-menu-groups]');
    var status = root.querySelector('[data-ami-status]');
    var configNode = root.querySelector('[data-ami-config]');
    var libraryNode = root.querySelector('[data-ami-library]');
    var overlay = root.querySelector('[data-ami-overlay]');
    var launch = root.querySelector('[data-ami-launch]');
    var stage = root.querySelector('[data-ami-stage]');

    if (!chat || !input || !send || !review || !memory || !memoryToggle || !memoryList || !menuGroups || !status || !configNode || !libraryNode || !overlay || !launch || !stage) {
      console.error('[Flayvr Ami v27] Required section markup is missing.');
      return;
    }

    var config = {};
    try {
      config = JSON.parse(configNode.textContent || '{}');
    } catch (error) {
      console.error('[Flayvr Ami v27] Invalid configuration JSON.', error);
    }

    var state = blankState();
    var savedRecord = null;
    var awaitingResume = false;

    function stepComplete(id) {
      return state.completed.indexOf(id) >= 0;
    }

    function markComplete(id) {
      if (!stepComplete(id)) state.completed.push(id);
    }

    function firstIncomplete() {
      for (var index = 0; index < STEPS.length; index += 1) {
        if (!stepComplete(STEPS[index].id)) return STEPS[index];
      }
      return null;
    }

    function coveragePlan() {
      return COVERAGE[String(state.coverage)] || COVERAGE['80'];
    }

    function save() {
      try {
        localStorage.setItem(STORAGE_KEY, JSON.stringify({
          state: clone(state),
          savedAt: Date.now(),
          version: VERSION
        }));

        LEGACY_KEYS.forEach(function (key) {
          localStorage.removeItem(key);
        });
      } catch (error) {
        console.warn('[Flayvr Ami v27] Could not save memory.', error);
      }
      renderMemory();
    }

    function clearSaved() {
      try {
        [STORAGE_KEY].concat(LEGACY_KEYS).forEach(function (key) {
          localStorage.removeItem(key);
        });
      } catch (error) {
        console.warn('[Flayvr Ami v27] Could not clear memory.', error);
      }
    }

    function migrateSaved(source) {
      var restored = blankState();
      var raw = source && source.state && typeof source.state === 'object' ? source.state : (source || {});

      restored.name = firstName(raw.name || raw.recipientName || raw.customerName || raw.firstName || '');
      restored.diet = list(raw.diet || raw.diets);
      restored.avoids = Array.isArray(raw.avoids)
        ? raw.avoids.join(', ')
        : String(raw.avoids || raw.avoidances || raw.dislikes || '');
      restored.spice = String(raw.spice || raw.heat || 'Medium');
      restored.coverage = COVERAGE[String(raw.coverage || raw.rhythm || raw.budget)]
        ? String(raw.coverage || raw.rhythm || raw.budget)
        : '80';
      restored.goal = list(raw.goal || raw.goals || raw.optimise || raw.support);
      restored.menu = Array.isArray(raw.menu)
        ? raw.menu
        : Array.isArray(source && source.currentMenu)
          ? source.currentMenu
          : [];
      restored.completed = Array.isArray(raw.completed)
        ? raw.completed.filter(function (id) {
            return STEPS.some(function (step) { return step.id === id; });
          })
        : Array.isArray(source && source.completedSteps)
          ? source.completedSteps.filter(function (id) {
              return STEPS.some(function (step) { return step.id === id; });
            })
          : [];

      if (!restored.completed.length && Number.isFinite(Number(raw.step))) {
        var legacyOrder = ['name', 'diet', 'avoids', 'coverage', 'spice', 'goal'];
        restored.completed = legacyOrder.slice(0, Math.max(0, Math.min(legacyOrder.length, Number(raw.step))));
      }

      if (!restored.completed.length) {
        if (raw.name || raw.recipientName || Number(raw.stepIndex) > 0) restored.completed.push('name');
        if (raw.coverage || raw.rhythm || raw.budget) restored.completed.push('coverage');
        if (restored.diet.length || Number(raw.stepIndex) >= 5) restored.completed.push('diet');
        if (restored.avoids || Number(raw.stepIndex) >= 6) restored.completed.push('avoids');
        if (raw.spice || raw.heat || Number(raw.stepIndex) >= 7) restored.completed.push('spice');
        if (restored.goal.length || Number(raw.stepIndex) >= 8) restored.completed.push('goal');
      }

      restored.editingCoverage = false;
      return restored;
    }

    function readSaved() {
      var keys = [STORAGE_KEY].concat(LEGACY_KEYS);

      for (var index = 0; index < keys.length; index += 1) {
        var key = keys[index];
        try {
          var parsed = JSON.parse(localStorage.getItem(key) || 'null');
          if (!parsed) continue;

          var savedAt = Number(parsed.savedAt || parsed.updatedAt || 0);
          if (!savedAt || Date.now() - savedAt > MEMORY_MS) {
            localStorage.removeItem(key);
            continue;
          }

          return {
            state: migrateSaved(parsed),
            savedAt: savedAt,
            key: key
          };
        } catch (error) {
          try { localStorage.removeItem(key); } catch (ignore) {}
        }
      }

      return null;
    }

    function applySaved(record) {
      Object.assign(state, blankState(), clone(record.state));
      state.diet = list(state.diet);
      state.goal = list(state.goal);
      state.completed = list(state.completed);
      state.menu = Array.isArray(state.menu) ? state.menu : [];
      state.editingCoverage = false;
    }

    function clearChat() {
      chat.innerHTML = '';
    }

    function addMessage(text, who) {
      var row = document.createElement('div');
      row.className = 'flami-msg flami-msg--' + (who === 'user' ? 'user' : 'ami');
      row.innerHTML = '<div class="flami-bubble">' + esc(text) + '</div>';
      chat.appendChild(row);
      chat.scrollTop = chat.scrollHeight;
      return row;
    }

    function addActionButtons(actions) {
      var box = document.createElement('div');
      box.className = 'flami-choices';

      actions.forEach(function (action) {
        var button = document.createElement('button');
        button.type = 'button';
        button.className = 'flami-choice';
        button.textContent = action[0];
        button.addEventListener('click', action[1]);
        box.appendChild(button);
      });

      chat.appendChild(box);
      chat.scrollTop = chat.scrollHeight;
      return box;
    }

    function setStepValue(step, value) {
      if (step.id === 'name') state.name = firstName(value);
      if (step.id === 'coverage') state.coverage = String(value);
      if (step.id === 'diet') {
        state.diet = list(value).filter(function (item) { return item !== 'No restrictions'; });
      }
      if (step.id === 'avoids') state.avoids = String(value || '').trim();
      if (step.id === 'spice') state.spice = String(value || 'Medium');
      if (step.id === 'goal') state.goal = list(value);

      if (['coverage', 'diet', 'avoids'].indexOf(step.id) >= 0) state.menu = [];
      markComplete(step.id);
      state.currentStepId = '';
      save();
    }

    function finishStep(step, value, label) {
      addMessage(label, 'user');
      setStepValue(step, value);

      if (state.editingCoverage) {
        state.editingCoverage = false;
        buildMenu();
        return;
      }

      setTimeout(askStep, 180);
    }

    function skipStep(step) {
      if (!step || !step.skippable) return;
      finishStep(step, step.type === 'multi' ? [] : '', 'Skip');
    }

    function addChoices(step) {
      var box = document.createElement('div');
      box.className = 'flami-choices';

      if (step.type === 'coverage') {
        Object.keys(COVERAGE).forEach(function (key) {
          var plan = COVERAGE[key];
          var button = document.createElement('button');
          button.type = 'button';
          button.className = 'flami-choice flami-choice--plan';
          button.dataset.value = key;
          button.innerHTML = '<strong>£' + plan.price + ' · ' + esc(plan.label) + '</strong><small>' + esc(plan.detail) + '</small>';
          button.addEventListener('click', function () {
            Array.prototype.forEach.call(box.querySelectorAll('button'), function (node) { node.disabled = true; });
            finishStep(step, key, plan.label);
          });
          box.appendChild(button);
        });
      } else if (step.choices) {
        step.choices.forEach(function (choice) {
          var button = document.createElement('button');
          button.type = 'button';
          button.className = 'flami-choice';
          button.textContent = choice;

          if (step.type === 'multi') {
            button.addEventListener('click', function () {
              button.classList.toggle('is-selected');

              if (choice === 'No restrictions' && button.classList.contains('is-selected')) {
                Array.prototype.forEach.call(box.querySelectorAll('.flami-choice'), function (node) {
                  if (node !== button) node.classList.remove('is-selected');
                });
              } else if (choice !== 'No restrictions' && button.classList.contains('is-selected')) {
                Array.prototype.forEach.call(box.querySelectorAll('.flami-choice'), function (node) {
                  if (node.textContent === 'No restrictions') node.classList.remove('is-selected');
                });
              }

              var next = box.querySelector('[data-next]');
              if (!next) {
                next = document.createElement('button');
                next.type = 'button';
                next.dataset.next = 'true';
                next.className = 'flami-choice';
                next.textContent = 'Continue';
                next.addEventListener('click', function () {
                  var values = Array.prototype.map.call(
                    box.querySelectorAll('.flami-choice.is-selected'),
                    function (node) { return node.textContent; }
                  );
                  if (!values.length) return;
                  Array.prototype.forEach.call(box.querySelectorAll('button'), function (node) { node.disabled = true; });
                  finishStep(step, values, values.join(', '));
                });
                box.appendChild(next);
              }

              next.disabled = box.querySelectorAll('.is-selected').length === 0;
            });
          } else {
            button.addEventListener('click', function () {
              Array.prototype.forEach.call(box.querySelectorAll('button'), function (node) { node.disabled = true; });
              finishStep(step, choice, choice);
            });
          }

          box.appendChild(button);
        });
      }

      if (step.skippable) {
        var skip = document.createElement('button');
        skip.type = 'button';
        skip.className = 'flami-choice';
        skip.textContent = 'Skip';
        skip.addEventListener('click', function () { skipStep(step); });
        box.appendChild(skip);
      }

      chat.appendChild(box);
      chat.scrollTop = chat.scrollHeight;
    }

    function askStep() {
      var step = firstIncomplete();
      if (!step) {
        buildMenu();
        return;
      }

      state.currentStepId = step.id;
      save();
      addMessage(step.question, 'ami');
      input.placeholder = step.placeholder || (step.type === 'text' ? 'Type your answer…' : 'You can also type a reply…');

      if (step.type !== 'text' || step.skippable) addChoices(step);
      input.focus({ preventScroll: true });
    }

    function matchCoverage(value) {
      var text = String(value || '').toLowerCase();
      if (/(^|\D)120(\D|$)/.test(text) || text.indexOf('full week') >= 0 || text.indexOf('seven day') >= 0 || text.indexOf('7 day') >= 0 || text.indexOf('breakfast') >= 0) return '120';
      if (/(^|\D)40(\D|$)/.test(text) || text.indexOf('weekday dinner') >= 0 || text.indexOf('dinners only') >= 0) return '40';
      if (/(^|\D)80(\D|$)/.test(text) || (text.indexOf('lunch') >= 0 && text.indexOf('dinner') >= 0)) return '80';
      return null;
    }

    function submitText() {
      var value = input.value.trim();
      if (!value) return;
      input.value = '';

      if (awaitingResume) {
        var typed = value.toLowerCase();
        if (/continue|resume|carry on/.test(typed)) {
          resumePlan();
          return;
        }
        if (/fresh|new plan|start again/.test(typed)) {
          startFresh();
          return;
        }
        addMessage('Choose Continue my plan or Start fresh.', 'ami');
        return;
      }

      if (state.editingCoverage) {
        var editedCoverage = matchCoverage(value);
        addMessage(value, 'user');
        if (!editedCoverage) {
          addMessage('Choose weekday dinners, weekday lunch and dinner, or the full seven-day plan.', 'ami');
          return;
        }
        setStepValue(STEPS.find(function (step) { return step.id === 'coverage'; }), editedCoverage);
        state.editingCoverage = false;
        buildMenu();
        return;
      }

      if (root.classList.contains('is-reviewing')) {
        root.classList.remove('is-reviewing');
        addMessage(value, 'user');
        state.avoids = [state.avoids, value].filter(Boolean).join(' · ');
        state.menu = [];
        save();
        addMessage('I’ve kept the rest of your profile and added that note.', 'ami');
        buildMenu();
        return;
      }

      var step = firstIncomplete();
      if (!step) {
        addMessage(value, 'user');
        state.avoids = [state.avoids, value].filter(Boolean).join(' · ');
        state.menu = [];
        save();
        buildMenu();
        return;
      }

      if (step.type === 'coverage') {
        var matched = matchCoverage(value);
        addMessage(value, 'user');
        if (!matched) {
          addMessage('Choose weekday dinners, weekday lunch and dinner, or the full seven-day plan.', 'ami');
          return;
        }
        setStepValue(step, matched);
        setTimeout(askStep, 180);
        return;
      }

      finishStep(step, step.type === 'multi' ? [value] : value, value);
    }

    function rawLibrary() {
      try {
        var parsed = JSON.parse(libraryNode.textContent || '[]') || [];
        return parsed.map(function (meal, index) {
          return {
            id: String(meal.id || meal.handle || index),
            handle: String(meal.handle || ''),
            name: String(meal.name || '').trim(),
            description: String(meal.description || '').trim(),
            image: String(meal.image || '').trim(),
            diet: list(meal.diet),
            ingredients: list(meal.ingredients),
            allergens: list(meal.allergens),
            supportTags: list(meal.supportTags),
            plan: list(meal.plan),
            mealType: list(meal.mealType),
            active: booleanValue(meal.active, true),
            available: booleanValue(meal.available, true),
            priority: Number(meal.priority || 0),
            calories: Number(meal.calories || 0),
            protein: Number(meal.protein || 0)
          };
        });
      } catch (error) {
        console.error('[Flayvr Ami v27] Invalid food-library JSON.', error);
        return [];
      }
    }

    function parseLibrary() {
      return rawLibrary().filter(function (meal) {
        return meal.name && meal.active && meal.available;
      });
    }

    function libraryDiagnostics() {
      var raw = rawLibrary();
      var named = raw.filter(function (meal) { return Boolean(meal.name); });
      var active = named.filter(function (meal) { return meal.active; });
      var available = active.filter(function (meal) { return meal.available; });

      return {
        configuredHandle: String(config.libraryHandle || ''),
        sourceUsed: String(config.librarySource || ''),
        liquidEntryCount: Number(config.libraryEntryCount || 0),
        rawJsonEntries: raw.length,
        namedEntries: named.length,
        activeEntries: active.length,
        availableEntries: available.length
      };
    }

    function mealTypeText(meal) {
      return cleanText(meal.mealType.concat([meal.name]).join(' '));
    }

    function typeOf(meal) {
      var text = mealTypeText(meal);
      if (text.indexOf('breakfast') >= 0) return 'Breakfast';
      if (text.indexOf('snack') >= 0 || text.indexOf('side') >= 0) return 'Snack';
      if (text.indexOf('lunch') >= 0) return 'Lunch';
      if (text.indexOf('dinner') >= 0) return 'Dinner';
      if (/\b(soup|salad|bowl|wrap)\b/.test(text)) return 'Lunch';
      return 'Dinner';
    }

    function supportsSlot(meal, slot) {
      var text = mealTypeText(meal);

      if (text.indexOf('breakfast') >= 0) return slot === 'Breakfast';
      if (text.indexOf('snack') >= 0 || text.indexOf('side') >= 0) return slot === 'Snack';
      if (text.indexOf('lunch') >= 0) return slot === 'Lunch';
      if (text.indexOf('dinner') >= 0) return slot === 'Dinner';

      if (/\b(main|meal|curry|ready made|ready-made|entree|entrée)\b/.test(text)) {
        return slot === 'Lunch' || slot === 'Dinner';
      }

      if (/\b(soup|salad|bowl|wrap)\b/.test(text)) {
        return slot === 'Lunch' || slot === 'Dinner';
      }

      return slot === 'Dinner';
    }

    function planAllows(meal) {
      var plans = list(meal.plan).map(function (value) {
        return value.replace(/[^0-9]/g, '');
      }).filter(Boolean);
      return !plans.length || plans.indexOf(String(state.coverage)) >= 0;
    }

    function exactTag(meal, patterns) {
      var tags = lower(meal.diet.concat(meal.supportTags)).map(cleanText).filter(function (tag) {
        return tag && !/^(non|not|contains)\s+/.test(tag);
      });

      return patterns.some(function (pattern) {
        var wanted = cleanText(pattern);
        return tags.some(function (tag) {
          return tag === wanted || tag.indexOf(wanted + ' ') === 0 || tag.endsWith(' ' + wanted) || tag.indexOf(' ' + wanted + ' ') >= 0;
        });
      });
    }

    function conflictText(meal) {
      return cleanText([
        meal.name,
        meal.description,
        meal.ingredients.join(' '),
        meal.allergens.join(' ')
      ].join(' '))
        .replace(/\b(vegan|plant based|meat free) (chicken|turkey|beef|lamb|pork|duck|fish|salmon|cod|prawn|shrimp|tuna|crab|lobster|cheese|milk|cream|butter|yogurt|yoghurt)\b/g, 'plant ingredient')
        .replace(/\b(coconut|oat|almond|soy|soya|cashew|rice|pea) (milk|cream|yogurt|yoghurt)\b/g, 'plant ingredient')
        .replace(/\bdairy free (cheese|milk|cream|butter|yogurt|yoghurt)\b/g, 'plant ingredient');
    }

    function hasLandMeat(meal) {
      return /\b(chicken|turkey|beef|lamb|pork|bacon|ham|duck|goat|venison|chorizo|sausage|sausages|meat|meatball|meatballs|kofta|keema)\b/.test(conflictText(meal));
    }

    function hasSeafood(meal) {
      return /\b(fish|salmon|cod|haddock|prawn|prawns|shrimp|shrimps|tuna|crab|lobster|mussel|mussels|clam|clams|anchovy|anchovies|sardine|sardines|mackerel|trout|seafood)\b/.test(conflictText(meal));
    }

    function hasAnimalProducts(meal) {
      return hasLandMeat(meal) || hasSeafood(meal) || /\b(egg|eggs|honey|cheese|cheddar|feta|halloumi|mozzarella|parmesan|ricotta|paneer|milk|cream|butter|ghee|yogurt|yoghurt|whey|casein|gelatin|gelatine)\b/.test(conflictText(meal));
    }

    function matchesDiet(meal) {
      var selected = lower(state.diet).filter(function (value) {
        return ['no restrictions', 'none'].indexOf(value) < 0;
      });

      return selected.every(function (diet) {
        if (diet === 'vegan') {
          return exactTag(meal, ['Vegan', 'VG', 'Plant based']) && !hasAnimalProducts(meal);
        }
        if (diet === 'vegetarian') {
          return exactTag(meal, ['Vegetarian', 'Vegan', 'VG', 'Plant based']) && !hasLandMeat(meal) && !hasSeafood(meal);
        }
        if (diet === 'pescatarian') {
          return exactTag(meal, ['Pescatarian', 'Fish', 'Seafood', 'Vegetarian', 'Vegan', 'VG']) && !hasLandMeat(meal);
        }
        if (diet === 'gluten-free' || diet === 'gluten free') {
          return exactTag(meal, ['Gluten-free', 'Gluten free', 'GF']);
        }
        if (diet === 'dairy-free' || diet === 'dairy free') {
          return exactTag(meal, ['Dairy-free', 'Dairy free', 'DF', 'Vegan', 'VG']);
        }
        return exactTag(meal, [diet]);
      });
    }

    function matchesAvoids(meal) {
      var avoids = lower(state.avoids).filter(function (value) {
        return ['none', 'nothing', 'nothing else'].indexOf(value) < 0;
      });
      if (!avoids.length) return true;

      var text = cleanText([
        meal.name,
        meal.description,
        meal.ingredients.join(' '),
        meal.allergens.join(' ')
      ].join(' '));

      return !avoids.some(function (avoid) {
        if (avoid === 'nuts' || avoid === 'nut') return /\b(nut|nuts|peanut|almond|cashew|walnut|pistachio|hazelnut)\b/.test(text);
        if (avoid === 'seafood') return hasSeafood(meal);
        if (avoid === 'red meat') return /\b(beef|lamb|pork|venison|goat)\b/.test(text);
        if (avoid === 'mushrooms') avoid = 'mushroom';
        return text.indexOf(avoid) >= 0;
      });
    }

    function scoreMeal(meal) {
      var score = Number(meal.priority || 0);
      var text = cleanText([meal.name, meal.description, meal.supportTags.join(' ')].join(' '));

      lower(state.goal).forEach(function (goal) {
        if (text.indexOf(goal) >= 0) score += 20;
        if (goal.indexOf('protein') >= 0 && (meal.protein >= 30 || /high protein/.test(text))) score += 18;
        if (goal.indexOf('gut') >= 0 && /gut|fibre|fiber|fermented|miso|kimchi|lentil|bean/.test(text)) score += 16;
        if (goal.indexOf('energy') >= 0 && /energy|steady|buckwheat|quinoa/.test(text)) score += 14;
        if (goal.indexOf('lighter') >= 0 && ((meal.calories > 0 && meal.calories < 560) || /lighter|fresh/.test(text))) score += 12;
        if (goal.indexOf('comfort') >= 0 && /comfort|warming|curry|dal|ragu|broth/.test(text)) score += 12;
      });

      return score;
    }

    function eligibleFor(slot, usedNames, library) {
      return (library || parseLibrary()).filter(function (meal) {
        return supportsSlot(meal, slot) &&
          planAllows(meal) &&
          matchesDiet(meal) &&
          matchesAvoids(meal) &&
          !usedNames.has(meal.name);
      }).sort(function (a, b) {
        return scoreMeal(b) - scoreMeal(a) || a.name.localeCompare(b.name);
      });
    }

    function shortageText(shortages) {
      return 'I can’t build this plan yet because the Shopify food library does not have enough matching meals. ' +
        shortages.map(function (item) {
          return item.slot.toLowerCase() + ': ' + item.available + ' suitable, ' + item.needed + ' needed';
        }).join('; ') +
        '. I have not substituted random meals. Missing meal images do not prevent a plan from being built.';
    }

    function buildMenu() {
      var plan = coveragePlan();
      var nextMenu = [];
      var shortages = [];
      var usedNames = new Set();
      var diagnostics = libraryDiagnostics();
      var library = parseLibrary();

      if (!library.length) {
        state.menu = [];
        save();
        root.classList.remove('is-reviewing');

        console.warn('[Flayvr Ami v27] Food library returned no usable storefront entries.', diagnostics);

        addMessage(
          'I’m refreshing the current menu library before I build your plan. Please try again, or start fresh if the menu has recently changed.',
          'ami'
        );
        status.textContent = '';
        return false;
      }

      Object.keys(plan.slots).forEach(function (slot) {
        var count = plan.slots[slot];
        var candidates = eligibleFor(slot, usedNames, library);

        if (candidates.length < count) {
          shortages.push({ slot: slot, available: candidates.length, needed: count });
          return;
        }

        candidates.slice(0, count).forEach(function (meal, index) {
          usedNames.add(meal.name);
          nextMenu.push({
            id: meal.id,
            handle: meal.handle,
            slot: slot,
            day: index + 1,
            name: meal.name,
            description: meal.description,
            image: meal.image,
            calories: meal.calories,
            protein: meal.protein
          });
        });
      });

      if (shortages.length) {
        state.menu = [];
        save();
        root.classList.remove('is-reviewing');
        addMessage(shortageText(shortages), 'ami');
        status.textContent = '';
        return false;
      }

      state.menu = nextMenu;
      save();
      showReview();
      return true;
    }

    function findSource(item, library) {
      return library.find(function (meal) {
        return String(meal.id) === String(item.id) ||
          (item.handle && meal.handle === item.handle) ||
          meal.name.toLowerCase() === String(item.name || '').toLowerCase();
      });
    }

    function menuStillValid(menu) {
      if (!Array.isArray(menu) || !menu.length) return false;

      var library = parseLibrary();
      var plan = coveragePlan();
      var counts = {};
      var seen = new Set();

      for (var index = 0; index < menu.length; index += 1) {
        var item = menu[index];
        var source = findSource(item, library);
        if (!source || !matchesDiet(source) || !matchesAvoids(source) || !planAllows(source)) return false;

        var slot = plan.slots[item.slot] && supportsSlot(source, item.slot)
          ? item.slot
          : typeOf(source);
        if (!plan.slots[slot] || !supportsSlot(source, slot) || seen.has(source.name)) return false;

        seen.add(source.name);
        counts[slot] = (counts[slot] || 0) + 1;

        item.id = source.id;
        item.handle = source.handle;
        item.slot = slot;
        item.name = source.name;
        item.description = source.description;
        item.image = source.image;
        item.calories = source.calories;
        item.protein = source.protein;
      }

      return Object.keys(plan.slots).every(function (slot) {
        return counts[slot] === plan.slots[slot];
      });
    }

    function renderMenu() {
      menuGroups.innerHTML = '';
      ['Breakfast', 'Lunch', 'Dinner', 'Snack'].forEach(function (slot) {
        var meals = state.menu.filter(function (meal) { return meal.slot === slot; });
        if (!meals.length) return;

        var section = document.createElement('section');
        section.className = 'flami-menu-group';
        section.innerHTML = '<h3>' + esc(slot) + (slot === 'Snack' ? 's' : '') + '</h3><div class="flami-meal-grid"></div>';
        var grid = section.querySelector('.flami-meal-grid');

        meals.forEach(function (meal) {
          var card = document.createElement('article');
          card.className = 'flami-meal' + (meal.image ? ' has-image' : ' has-no-image');

          var media = meal.image
            ? '<div class="flami-meal__media"><img src="' + esc(meal.image) + '" alt="" loading="lazy"></div>'
            : '<div class="flami-meal__media flami-meal__media--empty" aria-hidden="true"></div>';

          card.innerHTML =
            media +
            '<div class="flami-meal__content">' +
              '<small>Day ' + meal.day + '</small>' +
              '<strong>' + esc(meal.name) + '</strong>' +
              '<p>' + esc(meal.description) + '</p>' +
            '</div>';

          grid.appendChild(card);
        });

        menuGroups.appendChild(section);
      });
    }

    function showReview() {
      if (!menuStillValid(state.menu)) {
        state.menu = [];
        save();
        buildMenu();
        return;
      }

      var plan = coveragePlan();
      root.classList.add('is-reviewing');
      root.querySelector('[data-ami-price]').textContent = '£' + plan.price + ' / week';
      root.querySelector('[data-ami-coverage-summary]').textContent = plan.label;
      root.querySelector('[data-ami-diet-summary]').textContent = state.diet.join(', ') || 'No restrictions saved';
      root.querySelector('[data-ami-spice-summary]').textContent = (state.spice || 'Medium') + ' spice';
      renderMenu();
      renderMemory();
      review.scrollTop = 0;
    }

    function renderMemory() {
      var plan = coveragePlan();
      var bullets = [];
      if (state.name) bullets.push('Planning for ' + state.name);
      bullets.push(plan.label + ' · £' + plan.price + ' per week');
      if (state.diet.length) bullets.push(state.diet.join(', '));
      if (state.avoids) bullets.push('Avoid: ' + state.avoids);
      if (state.spice) bullets.push(state.spice + ' spice');
      if (state.goal.length) bullets.push(state.goal.join(', '));
      memoryList.innerHTML = bullets.map(function (item) { return '<li>' + esc(item) + '</li>'; }).join('') || '<li>No answers saved yet</li>';
    }

    function editCoverage() {
      root.classList.remove('is-reviewing');
      state.editingCoverage = true;
      addMessage('Everything else is still saved. Which coverage do you want instead?', 'ami');
      addChoices(STEPS.find(function (step) { return step.id === 'coverage'; }));
    }

    function editSingleAnswer(stepId) {
      var step = STEPS.find(function (item) { return item.id === stepId; });
      if (!step) return;
      root.classList.remove('is-reviewing');
      state.menu = [];
      state.completed = state.completed.filter(function (id) { return id !== stepId; });
      clearChat();
      addMessage('I’ve kept the rest of your profile. Let’s update just this answer.', 'ami');
      askStep();
    }

    function restartEditing() {
      root.classList.remove('is-reviewing');
      clearChat();
      addMessage('What would you like to change?', 'ami');
      addActionButtons([
        ['Who the meals are for', function () { editSingleAnswer('name'); }],
        ['Coverage', editCoverage],
        ['How I eat', function () { editSingleAnswer('diet'); }],
        ['Avoidances', function () { editSingleAnswer('avoids'); }],
        ['Spice', function () { editSingleAnswer('spice'); }],
        ['This week’s focus', function () { editSingleAnswer('goal'); }]
      ]);
    }

    function reset() {
      clearSaved();
      Object.assign(state, blankState());
      root.classList.remove('is-reviewing');
      clearChat();
      renderMemory();
      startNew();
    }

    function nextMonday(referenceDate) {
      var date = referenceDate ? new Date(referenceDate) : new Date();
      date.setHours(12, 0, 0, 0);
      var days = (8 - date.getDay()) % 7;
      if (!days) days = 7;
      date.setDate(date.getDate() + days);
      return date;
    }

    function formatDate(date) {
      try {
        return new Intl.DateTimeFormat('en-GB', {
          day: 'numeric',
          month: 'short',
          year: 'numeric'
        }).format(date);
      } catch (error) {
        return date.toISOString().slice(0, 10);
      }
    }

    function possessive(name) {
      if (!name) return 'Your';
      return /s$/i.test(name) ? name + "'" : name + "'s";
    }

    function pdfHtml() {
      var plan = coveragePlan();
      var week = nextMonday();
      var title = possessive(state.name) + ' personalised menu';

      var cards = state.menu.map(function (meal) {
        var colour = meal.slot === 'Lunch'
          ? '#31F01F'
          : meal.slot === 'Dinner'
            ? '#FF0038'
            : meal.slot === 'Breakfast'
              ? '#E9DAC6'
              : '#111114';
        var textColour = meal.slot === 'Dinner' || meal.slot === 'Snack' ? '#fff' : '#111';

        return '<article class="meal">' +
          '<span class="slot" style="background:' + colour + ';color:' + textColour + '">' + esc(meal.slot.toUpperCase()) + '</span>' +
          '<h3>' + esc(meal.name) + '</h3>' +
          '<p>' + esc(meal.description) + '</p>' +
          '<em>Chosen from your current Flayvr food profile.</em>' +
          '<div class="metrics">' +
            '<span>400g</span>' +
            (meal.calories ? '<span>' + Math.round(meal.calories) + ' kcal</span>' : '') +
            (meal.protein ? '<span>' + Math.round(meal.protein) + 'g protein</span>' : '') +
            '<span>' + esc((state.spice || 'Medium').toLowerCase()) + ' heat</span>' +
          '</div>' +
        '</article>';
      }).join('');

      var filename = (state.name || 'Customer')
        .replace(/[^a-z0-9]+/gi, '-')
        .replace(/^-|-$/g, '') +
        '-Ami-Menu-Week-' + week.toISOString().slice(0, 10);

      return '<!doctype html>' +
        '<html lang="en"><head><meta charset="utf-8"><meta name="viewport" content="width=device-width,initial-scale=1">' +
        '<title>' + esc(filename) + '</title>' +
        '<style>' +
        '*{box-sizing:border-box}body{margin:0;background:#eee8e3;color:#111;font-family:"Helvetica Neue",Arial,sans-serif}' +
        '.toolbar{position:sticky;top:0;z-index:5;display:flex;justify-content:center;gap:12px;padding:12px;background:#fff;border-bottom:1px solid #eee}' +
        '.toolbar button{border:0;border-radius:999px;padding:15px 24px;background:#E8343F;color:#fff;font-weight:800;font-size:15px;cursor:pointer}.toolbar button:last-child{background:#111}' +
        '.page{width:min(1120px,calc(100% - 36px));margin:28px auto;background:#fff;padding:40px 46px;box-shadow:0 24px 70px rgba(0,0,0,.1)}' +
        'header{display:grid;grid-template-columns:220px 1fr 220px;gap:16px;align-items:start;padding-bottom:24px;border-bottom:1px solid #eee5dd}' +
        '.logo{color:#E8343F;font-size:54px;font-weight:900;letter-spacing:-.07em;line-height:.9;text-transform:lowercase}' +
        '.title{text-align:center}.title small{color:#E8343F;font-size:11px;font-weight:900;letter-spacing:.12em;text-transform:uppercase}' +
        '.title h1{margin:8px 0 0;font-size:38px;line-height:1;letter-spacing:-.05em}.title p{margin:10px 0 0;color:#666}' +
        '.chips{display:flex;justify-content:flex-end;flex-wrap:wrap;gap:8px}.chip{border:1px solid #eee5dd;border-radius:999px;padding:9px 12px;font-size:12px}' +
        '.summary{display:grid;grid-template-columns:repeat(4,1fr);gap:12px;margin:22px 0}.summary div{border:1px solid #eee5dd;border-radius:18px;padding:14px}' +
        '.summary small{display:block;color:#888;font-size:9px;font-weight:900;letter-spacing:.11em;text-transform:uppercase}.summary strong{display:block;margin-top:7px;font-size:14px}' +
        '.menuhead{display:flex;justify-content:space-between;align-items:end;margin:24px 0 12px}.menuhead h2{margin:0;font-size:27px}.menuhead span{color:#666;font-size:13px}' +
        '.grid{display:grid;grid-template-columns:1fr 1fr;gap:12px}.meal{position:relative;min-height:185px;border:1px solid #eee5dd;border-radius:20px;padding:34px 20px 18px;break-inside:avoid}' +
        '.slot{position:absolute;top:0;right:18px;min-width:72px;padding:8px 13px;border-radius:0 0 13px 13px;font-size:10px;font-weight:900;letter-spacing:.09em;text-align:center}' +
        '.meal h3{max-width:82%;margin:0;font-size:20px;line-height:1.05}.meal p{margin:10px 0 0;color:#555;font-size:13px;line-height:1.4}.meal em{display:block;margin-top:10px;color:#777;font-size:11px}' +
        '.metrics{display:flex;gap:12px;flex-wrap:wrap;margin-top:12px;padding-top:10px;border-top:1px solid #eee5dd;color:#444;font-size:11px}' +
        '.footer{margin-top:22px;border-radius:18px;background:#111;color:#fff;padding:18px 20px;display:flex;justify-content:space-between;gap:20px}.footer p{margin:5px 0 0;color:#bbb;font-size:11px}.footer span{color:#E8343F;font-weight:800}' +
        '@media(max-width:760px){.page{width:100%;margin:0;padding:22px 16px}header{grid-template-columns:1fr;text-align:center}.chips{justify-content:center}.summary{grid-template-columns:1fr 1fr}.grid{grid-template-columns:1fr}}' +
        '@media print{body{background:#fff}.toolbar{display:none}.page{width:auto;margin:0;padding:0;box-shadow:none}header{grid-template-columns:150px 1fr 150px}.logo{font-size:42px}.title h1{font-size:30px}.summary{gap:6px;margin:12px 0}.summary div{padding:9px}.grid{gap:6px}.meal{min-height:145px;border-radius:12px;padding:27px 12px 10px}.meal h3{font-size:15px}.meal p{font-size:9px}.meal em,.metrics{font-size:8px}.footer{margin-top:10px;padding:12px 14px}}' +
        '</style></head><body>' +
        '<div class="toolbar"><button type="button" onclick="window.print()">Print / Save PDF</button><button type="button" onclick="window.close()">Close preview</button></div>' +
        '<main class="page"><header>' +
        '<div class="logo">' + esc(config.pdfBrand || 'flayvr') + '</div>' +
        '<div class="title"><small>Ami AI meal plan</small><h1>' + esc(title) + '</h1><p>Built from your answers, preferences and weekly rhythm.</p></div>' +
        '<div class="chips"><span class="chip">Week of ' + esc(formatDate(week)) + '</span><span class="chip">' + esc(plan.label) + '</span></div>' +
        '</header>' +
        '<section class="summary">' +
          '<div><small>Prepared for</small><strong>' + esc(state.name || 'Customer') + '</strong></div>' +
          '<div><small>Coverage</small><strong>' + esc(plan.label) + '</strong></div>' +
          '<div><small>Food profile</small><strong>' + esc(state.diet.join(', ') || 'No restrictions') + '</strong></div>' +
          '<div><small>Flavour</small><strong>' + esc(state.spice || 'Medium') + ' spice</strong></div>' +
        '</section>' +
        '<div class="menuhead"><h2>' + esc(possessive(state.name)) + ' menu</h2><span>' + esc(state.goal.join(', ') || 'A practical week') + '</span></div>' +
        '<section class="grid">' + cards + '</section>' +
        '<footer class="footer"><div><strong>Personalised by Ami. Cooked by Flayvr chefs.</strong><p>Every listed meal comes from the current Shopify food library.</p></div><span>flayvr.co.uk</span></footer>' +
        '</main></body></html>';
    }

    function downloadPdf() {
      if (!state.menu.length) {
        status.textContent = 'Build a valid menu first.';
        return;
      }

      var preview = window.open('', '_blank');
      if (!preview) {
        status.textContent = 'Allow pop-ups to open the branded PDF preview.';
        return;
      }

      preview.document.open();
      preview.document.write(pdfHtml());
      preview.document.close();
      preview.focus();
      status.textContent = 'Your personalised PDF preview is ready.';
    }

    async function checkout() {
      var id = config['variant' + state.coverage];
      var plan = coveragePlan();

      if (!id) {
        window.location.href = config.fallbackUrl || '/cart';
        return;
      }

      status.textContent = 'Adding your plan…';

      try {
        var response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({
            id: Number(id),
            quantity: 1,
            properties: {
              'Ami coverage': plan.label,
              'Ami price': '£' + plan.price,
              'Ami name': state.name,
              'Dietary profile': state.diet.join(', '),
              'Avoids': state.avoids,
              'Spice': state.spice,
              'Goals': state.goal.join(', '),
              'Ami menu': state.menu.map(function (meal) {
                return meal.slot + ' ' + meal.day + ': ' + meal.name;
              }).join(' | ')
            }
          })
        });

        if (!response.ok) throw new Error('Cart add failed');
        window.location.href = '/cart';
      } catch (error) {
        window.location.href = config.fallbackUrl || '/cart';
      }
    }

    function startNew() {
      awaitingResume = false;
      savedRecord = null;
      Object.assign(state, blankState());
      clearChat();
      addMessage('Hi, I’m Ami. I’ll ask only what I need to build a practical first menu.', 'ami');
      setTimeout(askStep, 180);
    }

    function startFresh() {
      clearSaved();
      root.classList.remove('is-reviewing');
      startNew();
    }

    function resumePlan() {
      if (!savedRecord) return;

      awaitingResume = false;
      applySaved(savedRecord);
      clearChat();
      renderMemory();

      if (menuStillValid(state.menu)) {
        addMessage('Welcome back' + (state.name ? ', ' + state.name : '') + '. I’ve restored your saved plan.', 'ami');
        showReview();
        return;
      }

      state.menu = [];
      save();

      if (firstIncomplete()) {
        addMessage('Welcome back' + (state.name ? ', ' + state.name : '') + '. I’ve restored your saved answers.', 'ami');
        setTimeout(askStep, 180);
      } else {
        addMessage('Welcome back' + (state.name ? ', ' + state.name : '') + '. I’ve restored your profile and I’m rebuilding the menu from the current Shopify food library.', 'ami');
        buildMenu();
      }
    }

    function showResumePrompt(record) {
      savedRecord = record;
      awaitingResume = true;
      clearChat();
      input.placeholder = 'Type Continue or Start fresh';
      addMessage('Welcome back' + (record.state.name ? ', ' + record.state.name : '') + '. I saved the plan you were building. Continue where you left off or start fresh?', 'ami');
      addActionButtons([
        ['Continue my plan', resumePlan],
        ['Start fresh', startFresh]
      ]);
    }

    send.addEventListener('click', submitText);
    input.addEventListener('keydown', function (event) {
      if (event.key === 'Enter') {
        event.preventDefault();
        submitText();
      }
    });

    memoryToggle.addEventListener('click', function () {
      var open = memory.classList.toggle('is-open');
      memoryToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      memoryToggle.querySelector('.flami-memory-toggle').textContent = open ? '−' : '+';
    });

    root.querySelector('[data-ami-change-plan]').addEventListener('click', editCoverage);
    root.querySelector('[data-ami-back-chat]').addEventListener('click', restartEditing);
    root.querySelector('[data-ami-edit-memory]').addEventListener('click', restartEditing);
    root.querySelector('[data-ami-clear-memory]').addEventListener('click', reset);
    root.querySelector('[data-ami-pdf]').addEventListener('click', downloadPdf);
    root.querySelector('[data-ami-checkout]').addEventListener('click', checkout);

    function openAmi() {
      root.classList.add('is-open');
      overlay.setAttribute('aria-hidden', 'false');
      document.documentElement.classList.add('flami-overlay-open');
      document.body.classList.add('flami-overlay-open');

      window.setTimeout(function () {
        var target = root.classList.contains('is-reviewing')
          ? root.querySelector('[data-ami-change-plan]')
          : input;
        if (target) target.focus({ preventScroll: true });
      }, 180);
    }

    function closeAmi() {
      root.classList.remove('is-open');
      overlay.setAttribute('aria-hidden', 'true');
      document.documentElement.classList.remove('flami-overlay-open');
      document.body.classList.remove('flami-overlay-open');
      if (launch) launch.focus({ preventScroll: true });
    }

    launch.addEventListener('click', openAmi);
    root.querySelector('[data-ami-close]').addEventListener('click', closeAmi);
    overlay.addEventListener('click', function (event) {
      if (event.target === overlay) closeAmi();
    });
    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && root.classList.contains('is-open')) closeAmi();
    });

    var publicApi = {
      version: VERSION,
      asset: 'flayvr-ami-final-v27-5.js',
      pdfTemplate: 'approved-grid-green-lunch-v1',
      getState: function () { return clone(state); },
      clearMemory: function () { clearSaved(); return true; },
      exportLibraryCsv: function () {
        var rows = parseLibrary();
        var headers = ['id', 'handle', 'name', 'meal_type', 'active', 'available', 'image_present', 'image_url', 'diet', 'ingredients', 'allergens', 'plan', 'priority', 'calories', 'protein'];
        var lines = [headers.join(',')];

        function csv(value) {
          var text = String(value == null ? '' : value);
          return /[",\n\r]/.test(text) ? '"' + text.replace(/"/g, '""') + '"' : text;
        }

        rows.forEach(function (meal) {
          var row = {
            id: meal.id,
            handle: meal.handle,
            name: meal.name,
            meal_type: typeOf(meal),
            active: meal.active,
            available: meal.available,
            image_present: Boolean(meal.image),
            image_url: meal.image,
            diet: meal.diet.join('; '),
            ingredients: meal.ingredients.join('; '),
            allergens: meal.allergens.join('; '),
            plan: meal.plan.join('; '),
            priority: meal.priority,
            calories: meal.calories,
            protein: meal.protein
          };
          lines.push(headers.map(function (header) { return csv(row[header]); }).join(','));
        });

        var blob = new Blob([lines.join('\r\n')], { type: 'text/csv;charset=utf-8' });
        var url = URL.createObjectURL(blob);
        var link = document.createElement('a');
        link.href = url;
        link.download = 'Flayvr-Ami-Library-Audit-' + new Date().toISOString().slice(0, 10) + '.csv';
        document.body.appendChild(link);
        link.click();
        link.remove();
        setTimeout(function () { URL.revokeObjectURL(url); }, 1000);
        return rows;
      },
      libraryDiagnostics: function () {
        return libraryDiagnostics();
      },
      healthCheck: function () {
        var library = parseLibrary();
        var withImages = library.filter(function (meal) { return Boolean(meal.image); });
        var unsafe = state.menu.filter(function (item) {
          var source = findSource(item, library);
          return !source || !matchesDiet(source) || !matchesAvoids(source) || !planAllows(source);
        });
        var missingImages = state.menu.filter(function (item) {
          var source = findSource(item, library);
          return source && !source.image;
        });
        var suitableBySlot = {};
        var imageReadyBySlot = {};

        ['Breakfast', 'Lunch', 'Dinner', 'Snack'].forEach(function (slot) {
          suitableBySlot[slot] = library.filter(function (meal) {
            return supportsSlot(meal, slot) &&
              planAllows(meal) &&
              matchesDiet(meal) &&
              matchesAvoids(meal);
          }).length;

          imageReadyBySlot[slot] = withImages.filter(function (meal) {
            return supportsSlot(meal, slot) &&
              planAllows(meal) &&
              matchesDiet(meal) &&
              matchesAvoids(meal);
          }).length;
        });

        return {
          ok: unsafe.length === 0 && library.length > 0,
          imagesOptional: true,
          librarySource: libraryDiagnostics(),
          diet: clone(state.diet),
          libraryMeals: library.length,
          mealsWithImages: withImages.length,
          mealsWithoutImages: library.length - withImages.length,
          suitableBySlot: suitableBySlot,
          imageReadyBySlot: imageReadyBySlot,
          menuItems: state.menu.length,
          menuItemsWithoutImages: missingImages.map(function (item) { return item.name; }),
          unsafeMeals: unsafe.map(function (item) { return item.name; }),
          pdfTemplate: 'approved-grid-green-lunch-v1'
        };
      }
    };

    window.FlayvrAmi = publicApi;
    root.__flayvrAmi = publicApi;

    savedRecord = readSaved();
    renderMemory();

    if (savedRecord) showResumePrompt(savedRecord);
    else startNew();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { bootAll(document); }, { once: true });
  } else {
    bootAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    bootAll(event.target || document);
  });
})();
